/* =============================================================
   WRIGHTSOCK — PDP JavaScript
   Gallery thumbnails, color swatches, size helper,
   custom qty stepper, ATC price label, mobile sticky bar
   ============================================================= */

(function () {
  'use strict';

  /* ── helpers ─────────────────────────────────────────────── */
  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  var isVariantTemplate = !!qs('#ws-pdp-variant-gallery-json');

  /* ═══════════════════════════════════════════════════════════
     SLIDER (variant-functionality template only)
     ═══════════════════════════════════════════════════════════ */
  var sliderState = { current: 0, total: 0 };

  function initSlider() {
    if (!isVariantTemplate) return;
    var track = qs('#ws-pdp-slider-track');
    if (!track) return;

    /* ── translate the track to show slide at index ── */
    function applyTranslate(offset, animated) {
      track.style.transition = animated ? 'transform 0.3s ease' : 'none';
      track.style.transform  = 'translateX(' + offset + 'px)';
    }

    function goTo(index) {
      var slides = qsa('.ws-pdp-slide', track);
      if (!slides.length) return;
      index = Math.max(0, Math.min(index, slides.length - 1));
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
      });
      sliderState.current = index;
      sliderState.total   = slides.length;
      /* slide the track: each slide is 100% of the wrapper width */
      var slideWidth = track.parentElement ? track.parentElement.offsetWidth : track.offsetWidth;
      applyTranslate(-(index * slideWidth), true);
      syncThumbActive(index);
    }

    /* ── drag / swipe — mouse + touch + touchpad ── */
    var dragStartX  = 0;
    var dragDelta   = 0;
    var dragging    = false;
    var THRESHOLD   = 50;
    var baseOffset  = 0; /* track offset at drag start */

    function getBaseOffset() {
      var slideWidth = track.parentElement ? track.parentElement.offsetWidth : track.offsetWidth;
      return -(sliderState.current * slideWidth);
    }

    function onDragStart(clientX) {
      dragStartX = clientX;
      dragDelta  = 0;
      dragging   = true;
      baseOffset = getBaseOffset();
      track.style.transition = 'none';
      track.style.cursor     = 'grabbing';
    }

    function onDragMove(clientX) {
      if (!dragging) return;
      dragDelta = clientX - dragStartX;
      var slides = qsa('.ws-pdp-slide', track);
      var clamped = dragDelta;
      /* rubber-band: resist dragging past first/last */
      if ((sliderState.current === 0 && dragDelta > 0) ||
          (sliderState.current >= slides.length - 1 && dragDelta < 0)) {
        clamped = dragDelta * 0.2;
      }
      track.style.transform = 'translateX(' + (baseOffset + clamped) + 'px)';
    }

    function onDragEnd() {
      if (!dragging) return;
      dragging = false;
      track.style.cursor = '';
      if (Math.abs(dragDelta) >= THRESHOLD) {
        goTo(sliderState.current + (dragDelta < 0 ? 1 : -1));
      } else {
        /* snap back */
        applyTranslate(getBaseOffset(), true);
      }
      dragDelta = 0;
    }

    /* mouse */
    track.addEventListener('mousedown', function (e) {
      e.preventDefault();
      onDragStart(e.clientX);
    });
    window.addEventListener('mousemove', function (e) {
      if (dragging) onDragMove(e.clientX);
    });
    window.addEventListener('mouseup', function () {
      if (dragging) onDragEnd();
    });

    /* touch */
    track.addEventListener('touchstart', function (e) {
      onDragStart(e.touches[0].clientX);
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (dragging) onDragMove(e.touches[0].clientX);
    }, { passive: true });
    track.addEventListener('touchend', function () {
      if (dragging) onDragEnd();
    });

    /* two-finger touchpad — wheel events with debounce so one swipe = one slide */
    var wheelCooldown = false;
    track.addEventListener('wheel', function (e) {
      var dx = Math.abs(e.deltaX);
      var dy = Math.abs(e.deltaY);
      /* only handle clearly horizontal swipes; ignore vertical page scroll */
      if (dx < 5 && dy > dx) return;
      e.preventDefault();
      if (wheelCooldown) return;
      wheelCooldown = true;
      goTo(sliderState.current + (e.deltaX > 0 ? 1 : -1));
      setTimeout(function () { wheelCooldown = false; }, 600);
    }, { passive: false });

    /* keyboard */
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  goTo(sliderState.current - 1);
      if (e.key === 'ArrowRight') goTo(sliderState.current + 1);
    });

    /* re-snap on resize (slide width changes) */
    window.addEventListener('resize', function () {
      applyTranslate(getBaseOffset(), false);
    });

    /* expose for rebuild */
    window.wsPdpSliderGoTo = goTo;

    /* init */
    goTo(0);
  }

  function syncThumbActive(slideIndex) {
    var thumbs = qsa('.ws-pdp-slide-thumb');
    thumbs.forEach(function (t) {
      var idx = parseInt(t.dataset.slideIndex, 10);
      t.classList.toggle('is-active', idx === slideIndex);
      t.setAttribute('aria-selected', idx === slideIndex ? 'true' : 'false');
    });
  }

  /* ═══════════════════════════════════════════════════════════
     GALLERY (non-slider templates)
     ═══════════════════════════════════════════════════════════ */
  function initGallery() {
    if (isVariantTemplate) return; /* slider template has its own logic */
    var stage      = qs('.ws-pdp-stage-img');
    var thumbsWrap = qs('.ws-pdp-thumbs');
    if (!stage || !thumbsWrap) return;

    function setImage(src, alt, thumbEl) {
      stage.classList.add('is-loading');
      var img = new Image();
      img.onload = function () {
        stage.src = src;
        if (alt) stage.alt = alt;
        stage.classList.remove('is-loading');
      };
      img.src = src;
      qsa('.ws-pdp-thumb', thumbsWrap).forEach(function (t) { t.classList.remove('is-active'); });
      if (thumbEl) thumbEl.classList.add('is-active');
    }

    /* delegated — works for both default and injected lifestyle thumbs */
    thumbsWrap.addEventListener('click', function (e) {
      var thumb = e.target.closest('.ws-pdp-thumb');
      if (!thumb) return;
      var src = thumb.dataset.image;
      var alt = thumb.dataset.alt || '';
      if (src) setImage(src, alt, thumb);
    });

    window.wsPdpSetImage = setImage;
  }

  /* ═══════════════════════════════════════════════════════════
     LIFESTYLE GALLERY — color-based thumbs from
     custom.lifestyle_images (non-slider templates only).
     Falls back to the default product.media thumbs.
     ═══════════════════════════════════════════════════════════ */
  var lifestyleGalleryData  = null;
  var defaultThumbsHTML     = null;
  var currentLifestyleColor = null;

  function initLifestyleGallery() {
    if (isVariantTemplate) return;
    var jsonEl     = qs('#ws-pdp-lifestyle-gallery-json');
    var thumbsWrap = qs('.ws-pdp-thumbs');
    if (!jsonEl || !thumbsWrap) return;
    try { lifestyleGalleryData = JSON.parse(jsonEl.textContent); }
    catch (e) { return; }
    defaultThumbsHTML = thumbsWrap.innerHTML;   /* snapshot = fallback */
    /* The initial color's thumbs are already server-rendered by Liquid
       (lifestyle images or the current variant's image) — no JS rebuild on
       load, so the metafield images are visible immediately. Just record
       the color so updateLifestyleGallery only acts on real color changes. */
    var activeSwatch = qs('.ws-pdp-swatch.is-active');
    if (activeSwatch) currentLifestyleColor = activeSwatch.dataset.color;
  }

  function updateLifestyleGallery(colorKey) {
    if (isVariantTemplate || !lifestyleGalleryData || defaultThumbsHTML === null) return;
    if (colorKey === currentLifestyleColor) return;  /* size/height switches = no-op */
    var thumbsWrap = qs('.ws-pdp-thumbs');
    if (!thumbsWrap) return;
    currentLifestyleColor = colorKey;

    /* First thumb is always the new color's own product image (what the
       swatch click just put on the stage), so the shopper can come back
       to it after viewing a lifestyle photo. */
    var sockSwatch = qs('.ws-pdp-swatch.is-active');
    var sockSrc    = sockSwatch ? sockSwatch.dataset.image : '';
    var sockAlt    = sockSwatch ? (sockSwatch.dataset.color || '').replace(/"/g, '&quot;') : '';

    var images = lifestyleGalleryData[String(colorKey)];
    if (images && images.length) {
      var thumbs = [];
      if (sockSrc) {
        thumbs.push(
          '<button class="ws-pdp-thumb is-active" type="button"' +
          ' data-image="' + sockSrc + '" data-alt="' + sockAlt + '"' +
          ' role="tab" aria-selected="true" aria-label="View product image">' +
          '<img src="' + sockSrc.replace(/([?&])width=\d+/, '$1width=160') + '" alt="' + sockAlt + '" width="76" height="76" loading="lazy">' +
          '</button>'
        );
      }
      images.forEach(function (img, i) {
        var active = !sockSrc && i === 0;
        thumbs.push(
          '<button class="ws-pdp-thumb' + (active ? ' is-active' : '') + '" type="button"' +
          ' data-image="' + img.src + '" data-alt="' + img.alt + '"' +
          ' role="tab" aria-selected="' + (active ? 'true' : 'false') + '"' +
          ' aria-label="View image ' + (i + 2) + '">' +
          '<img src="' + img.thumb + '" alt="' + img.alt + '" width="76" height="76" loading="lazy">' +
          '</button>'
        );
      });
      thumbsWrap.innerHTML = thumbs.join('');
    } else {
      /* No lifestyle images for this color: the single fallback thumb mirrors
         the image currently open on the stage (the active color's own image),
         not the product's first featured image. */
      var activeSwatch = qs('.ws-pdp-swatch.is-active');
      var stageSrc = activeSwatch ? activeSwatch.dataset.image : '';
      if (stageSrc) {
        var thumbSrc = stageSrc.replace(/([?&])width=\d+/, '$1width=160');
        var altText = (activeSwatch.dataset.color || '').replace(/"/g, '&quot;');
        thumbsWrap.innerHTML =
          '<button class="ws-pdp-thumb is-active" type="button"' +
          ' data-image="' + stageSrc + '" data-alt="' + altText + '"' +
          ' role="tab" aria-selected="true" aria-label="View image 1">' +
          '<img src="' + thumbSrc + '" alt="' + altText + '" width="76" height="76" loading="lazy">' +
          '</button>';
      } else {
        thumbsWrap.innerHTML = defaultThumbsHTML;   /* featured image — last resort */
      }
    }
  }

  /* ═══════════════════════════════════════════════════════════
     REBUILD slider + thumbnails from variant metafield JSON
     (variant-functionality template only)
     Key: color value string (e.g. "Light Gray")
     ═══════════════════════════════════════════════════════════ */
  function rebuildGalleryForColor(colorKey) {
    if (!isVariantTemplate) return false;
    var track     = qs('#ws-pdp-slider-track');
    var galleryEl = qs('#ws-pdp-variant-gallery-json');
    if (!track || !galleryEl) return false;

    var galleryData;
    try { galleryData = JSON.parse(galleryEl.textContent); }
    catch (e) { return false; }

    var images = galleryData[String(colorKey)];
    if (!images || !images.length) return false;

    /* ── rebuild slider track ── */
    track.innerHTML = images.map(function (img, i) {
      return '<div class="ws-pdp-slide' + (i === 0 ? ' is-active' : '') + '" data-index="' + i + '">' +
        '<img src="' + img.src + '" alt="' + img.alt + '" width="900" height="900" loading="' + (i === 0 ? 'eager' : 'lazy') + '">' +
        '</div>';
    }).join('');

    /* ── overlay thumbnail area now holds the lifestyle image only;
          it is updated per-variant by syncVariant(), not rebuilt here ── */

    /* reset slider */
    sliderState.current = 0;
    sliderState.total   = images.length;
    if (window.wsPdpSliderGoTo) window.wsPdpSliderGoTo(0);

    return true;
  }

  /* ═══════════════════════════════════════════════════════════
     COLOR SWATCHES
     ═══════════════════════════════════════════════════════════ */
  function initSwatches() {
    var swatches   = qsa('.ws-pdp-swatch');
    var colorValue = qs('#ws-pdp-color-value');
    if (!swatches.length) return;

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('is-active'); });
        swatch.classList.add('is-active');

        if (colorValue) colorValue.textContent = swatch.dataset.color || '';

        if (isVariantTemplate) {
          /* rebuild slider + thumbs from color-keyed metafield data */
          rebuildGalleryForColor(swatch.dataset.color);
        } else {
          /* non-variant templates: plain image swap */
          var img = swatch.dataset.image;
          if (img && window.wsPdpSetImage) {
            window.wsPdpSetImage(img, swatch.dataset.color || '', null);
          }
          updateLifestyleGallery(swatch.dataset.color);
        }

        syncVariant();
      });
    });

    /* ── color thumbs (left strip on variant template) ── */
    /* These are the per-color swatches in the thumbnail area */
    qsa('.ws-pdp-thumb[data-color]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var color     = thumb.dataset.color;
        var matchingSwatch = qs('.ws-pdp-swatch[data-color="' + CSS.escape(color) + '"]');

        /* activate swatch */
        swatches.forEach(function (s) { s.classList.remove('is-active'); });
        if (matchingSwatch) {
          matchingSwatch.classList.add('is-active');
          if (colorValue) colorValue.textContent = color;
        }

        /* activate this thumb */
        qsa('.ws-pdp-thumb[data-color]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');

        rebuildGalleryForColor(color);
        syncVariant();
      });
    });
  }

  /* ═══════════════════════════════════════════════════════════
     SIZE BUTTONS
     ═══════════════════════════════════════════════════════════ */

  /* ── explicit size selection state ──
     Liquid renders no pre-selected size pill (and an empty input[name=id])
     when the product has a real Size choice, so "no .is-active size pill"
     IS the placeholder state — the shopper must pick one before ATC. */
  function sizeGroupExists() { return qsa('.ws-pdp-size-btn').length > 0; }
  function activeSizeBtn()   { return qs('.ws-pdp-size-btn.is-active'); }
  function showSizeError() {
    var el = qs('.ws-pdp-size-error');
    if (!el) return;
    el.hidden = false;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function hideSizeError() {
    var el = qs('.ws-pdp-size-error');
    if (el) el.hidden = true;
  }

  /* Belt-and-suspenders: if a submit ever slips past the guard (stale
     cached JS, unexpected path) Shopify answers "Cannot find variant"
     into Dawn's error wrapper at the top of the form. While no size is
     selected, swallow that raw error and show our size message instead. */
  function initServerErrorRelay() {
    var wrapper = qs('.product-form__error-message-wrapper');
    if (!wrapper || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      if (wrapper.hidden) return;
      if (sizeGroupExists() && !activeSizeBtn()) {
        wrapper.hidden = true;
        showSizeError();
      }
    }).observe(wrapper, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true });
  }

  function initSizes() {
    var sizeBtns = qsa('.ws-pdp-size-btn');
    var sizeHelp = qs('.ws-pdp-size-help');
    if (!sizeBtns.length) return;

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-soldout')) return;
        sizeBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        hideSizeError();
        if (sizeHelp) sizeHelp.textContent = btn.dataset.sizeHelp || '';
        updateAtcPrice();
        syncVariant();
      });
    });
  }

  /* ═══════════════════════════════════════════════════════════
     GENERIC OPTION BUTTONS (any option beyond Color/Size)
     ═══════════════════════════════════════════════════════════ */
  function initExtraOptions() {
    qsa('[data-ws-pdp-option-name]').forEach(function (group) {
      var btns = qsa('.ws-pdp-extra-option-btn', group);
      var valueEl = group.querySelector('.ws-pdp-option-value');
      if (!btns.length) return;

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-soldout')) return;
          btns.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (valueEl) valueEl.textContent = btn.dataset.optionValue || '';
          syncVariant();
        });
      });
    });
  }

  /* ═══════════════════════════════════════════════════════════
     VARIANT SYNC
     ═══════════════════════════════════════════════════════════ */
  function optionIndex(el, key) {
    var raw = el ? el.dataset[key] : undefined;
    var idx = parseInt(raw, 10);
    return isNaN(idx) ? null : idx;
  }

  function syncVariant() {
    var variantsEl = qs('#ws-pdp-variants-json');
    if (!variantsEl) return;

    var colorIdx = optionIndex(variantsEl, 'colorIndex');
    var sizeIdx  = optionIndex(variantsEl, 'sizeIndex');

    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

    /* hide combinations that were never created, grey real sold-outs and
       re-home the selection if its pill was hidden — all BEFORE matching */
    updateOptionStates(variants, colorIdx, sizeIdx);

    /* Size option exists but nothing chosen yet — placeholder state.
       Never resolve a variant id from Color/Height alone; keep the ATC
       clickable (when any size is buyable) so the submit guard can explain
       what's missing. */
    if (sizeIdx !== null && sizeGroupExists() && !activeSizeBtn()) {
      var placeholderIdInput = qs('input[name="id"]');
      if (placeholderIdInput) placeholderIdInput.value = '';
      var anyBuyable = qsa('.ws-pdp-size-btn').some(function (b) {
        return !b.hidden && !b.classList.contains('is-soldout');
      });
      updateAtcAvailability(anyBuyable);
      return;
    }

    var activeColor = qs('.ws-pdp-swatch.is-active');
    var activeSize  = qs('.ws-pdp-size-btn.is-active');
    var activeExtras = qsa('[data-ws-pdp-option-name]').map(function (group) {
      var active = group.querySelector('.ws-pdp-extra-option-btn.is-active');
      if (!active) return null;
      return { idx: optionIndex(group, 'optionIndex'), val: active.dataset.optionValue };
    }).filter(Boolean);
    if (!activeColor && !activeSize && !activeExtras.length) return;

    var colorVal = activeColor ? activeColor.dataset.color : null;
    var sizeVal  = activeSize  ? activeSize.dataset.size   : null;

    /* exact match: each selected option must sit at its own position */
    function matchesSelection(v) {
      if (colorVal !== null) {
        if (colorIdx !== null) { if (v.options[colorIdx] !== colorVal) return false; }
        else if (!v.options.includes(colorVal)) return false;
      }
      if (sizeVal !== null) {
        if (sizeIdx !== null) { if (v.options[sizeIdx] !== sizeVal) return false; }
        else if (!v.options.includes(sizeVal)) return false;
      }
      return activeExtras.every(function (extra) {
        if (extra.idx !== null) return v.options[extra.idx] === extra.val;
        return v.options.includes(extra.val);
      });
    }

    var match = variants.find(matchesSelection);

    if (match) {
      var input = qs('input[name="id"]');
      if (input) input.value = match.id;
      updateAtcPrice(match.price_formatted);
      updateAtcAvailability(match.available);
      // updateLifestyleThumb(match.lifestyle); // Lifestyle image — DISABLED
    } else {
      /* selected combination doesn't exist — never leave a stale enabled button */
      updateAtcAvailability(false);
    }
  }

  /* ── current selection as { optionPosition: value } for every active pill ── */
  function getSelections(colorIdx, sizeIdx) {
    var sel = {};
    var activeColor = qs('.ws-pdp-swatch.is-active');
    if (activeColor && colorIdx !== null) sel[colorIdx] = activeColor.dataset.color;
    var activeSize = qs('.ws-pdp-size-btn.is-active');
    if (activeSize && !activeSize.hidden && sizeIdx !== null) sel[sizeIdx] = activeSize.dataset.size;
    qsa('[data-ws-pdp-option-name]').forEach(function (group) {
      var idx = optionIndex(group, 'optionIndex');
      var active = group.querySelector('.ws-pdp-extra-option-btn.is-active');
      if (idx !== null && active && !active.hidden) sel[idx] = active.dataset.optionValue;
    });
    return sel;
  }

  /* ── one pill group: hide values with no variant at all, grey values whose
     variants all lack stock — both scoped to the options selected at EARLIER
     positions (preceding-option rule: Color is never filtered, Size is
     filtered by Color, Height by Color + Size). ── */
  function updateGroupStates(variants, groupIdx, buttons, valueKey, selections) {
    buttons.forEach(function (btn) {
      var value = btn.dataset[valueKey];
      var exists = false;
      var available = false;
      variants.forEach(function (v) {
        if (v.options[groupIdx] !== value) return;
        for (var idx in selections) {
          if (Number(idx) < groupIdx && v.options[idx] !== selections[idx]) return;
        }
        exists = true;
        if (v.available) available = true;
      });
      btn.hidden = !exists;                                     /* never created → not rendered */
      btn.classList.toggle('is-soldout', exists && !available); /* created, no stock → Sold Out */
      if (exists && !available) btn.setAttribute('aria-disabled', 'true');
      else btn.removeAttribute('aria-disabled');
    });
  }

  /* ── if a group's active pill got hidden: for the Size group, clear the
     selection so the shopper must re-choose (explicit-selection rule); for
     other groups, move it to the first visible pill (preferring in-stock)
     and mirror what that group's click handler would have updated. A group
     with NO active pill at all is the deliberate "Select Size" placeholder
     state — never invent a selection for it. ── */
  function reselectIfHidden(buttons, onSelect, clearOnHidden) {
    var active = buttons.find(function (b) { return b.classList.contains('is-active'); });
    if (!active || !active.hidden) return;
    if (clearOnHidden) {
      active.classList.remove('is-active');
      if (onSelect) onSelect(null);
      return;
    }
    var next =
      buttons.find(function (b) { return !b.hidden && !b.classList.contains('is-soldout'); }) ||
      buttons.find(function (b) { return !b.hidden; });
    if (!next) return;
    buttons.forEach(function (b) { b.classList.remove('is-active'); });
    next.classList.add('is-active');
    if (onSelect) onSelect(next);
  }

  /* ── recompute every pill group in option-position order so the filter
     cascades: Color → Size → Height/anything else ── */
  function updateOptionStates(variants, colorIdx, sizeIdx) {
    var groups = [];

    if (sizeIdx !== null) {
      groups.push({
        idx: sizeIdx,
        buttons: qsa('.ws-pdp-size-btn'),
        valueKey: 'size',
        clearOnHidden: true,
        onSelect: function (btn) {
          var sizeHelp = qs('.ws-pdp-size-help');
          if (sizeHelp) sizeHelp.textContent = btn ? (btn.dataset.sizeHelp || '') : '';
        }
      });
    }

    qsa('[data-ws-pdp-option-name]').forEach(function (group) {
      var idx = optionIndex(group, 'optionIndex');
      if (idx === null) return;
      groups.push({
        idx: idx,
        buttons: qsa('.ws-pdp-extra-option-btn', group),
        valueKey: 'optionValue',
        onSelect: function (btn) {
          var valueEl = group.querySelector('.ws-pdp-option-value');
          if (valueEl) valueEl.textContent = btn.dataset.optionValue || '';
        }
      });
    });

    groups.sort(function (a, b) { return a.idx - b.idx; });

    groups.forEach(function (g) {
      var selections = getSelections(colorIdx, sizeIdx); /* re-read so reselects cascade */
      updateGroupStates(variants, g.idx, g.buttons, g.valueKey, selections);
      reselectIfHidden(g.buttons, g.onSelect, g.clearOnHidden);
    });
  }

  /* ── lifestyle image overlay (bottom-left of stage) on variant change — DISABLED ── */
  // function updateLifestyleThumb(src) {
  //   var strip = qs('#ws-pdp-slide-thumbs');
  //   var wrap  = qs('#ws-pdp-lifestyle-thumb');
  //   if (!strip || !wrap) return;
  //   var img = wrap.querySelector('img');
  //   if (src && img) {
  //     img.src = src;
  //     strip.hidden = false;
  //   } else {
  //     strip.hidden = true;
  //   }
  // }

  /* ── ATC disabled/label state on variant change ──
     Labels come from data attributes rendered by Liquid, never from the
     button's current text — reading the text back captured "Sold out" as
     the default whenever the page loaded on an unavailable variant. */
  function updateAtcAvailability(available) {
    var atcBtn = qs('.ws-pdp-atc');
    var labelEl = qs('.ws-pdp-atc-label');
    if (!atcBtn || !labelEl) return;

    var defaultLabel = atcBtn.dataset.defaultLabel || 'Add to Cart';
    var soldOutLabel = atcBtn.dataset.soldOutLabel || 'Sold out';
    atcBtn.disabled = !available;
    labelEl.textContent = available ? defaultLabel : soldOutLabel;
  }

  /* ── apply exists/sold-out pill states for the initially selected variant on load ── */
  function initSoldoutStates() {
    var variantsEl = qs('#ws-pdp-variants-json');
    if (!variantsEl) return;
    try {
      updateOptionStates(
        JSON.parse(variantsEl.textContent),
        optionIndex(variantsEl, 'colorIndex'),
        optionIndex(variantsEl, 'sizeIndex')
      );
    } catch (e) {}
  }

  /* ── last line of defence: a sold-out variant must never submit,
     even if the button's disabled state was lost somewhere.
     Capture phase on document so this runs before product-form.js. ── */
  function initAtcGuard() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.id !== 'ws-product-form') return;

      /* explicit size selection required before anything else */
      if (sizeGroupExists() && !activeSizeBtn()) {
        e.preventDefault();
        e.stopPropagation();
        showSizeError();
        return;
      }

      var variantsEl = qs('#ws-pdp-variants-json');
      var idInput = form.querySelector('input[name="id"]');
      if (!variantsEl || !idInput) return;
      try {
        var variants = JSON.parse(variantsEl.textContent);
        var selected = variants.find(function (v) { return String(v.id) === String(idInput.value); });
        if (selected && !selected.available) {
          e.preventDefault();
          e.stopPropagation();
          updateAtcAvailability(false);
        }
      } catch (err) {}
    }, true);
  }

  /* ═══════════════════════════════════════════════════════════
     QTY STEPPER
     ═══════════════════════════════════════════════════════════ */
  function initQty() {
    var minusBtn = qs('.ws-pdp-qty-btn[data-action="minus"]');
    var plusBtn  = qs('.ws-pdp-qty-btn[data-action="plus"]');
    var valEl    = qs('.ws-pdp-qty-val');
    var qtyInput = qs('.ws-pdp-qty-input');
    if (!minusBtn || !plusBtn || !valEl) return;

    var qty = 1;
    function setQty(n) {
      qty = Math.max(1, n);
      valEl.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      minusBtn.disabled = qty <= 1;
    }
    minusBtn.addEventListener('click', function () { setQty(qty - 1); });
    plusBtn.addEventListener('click',  function () { setQty(qty + 1); });
    setQty(1);
  }

  /* ═══════════════════════════════════════════════════════════
     ATC PRICE LABEL
     ═══════════════════════════════════════════════════════════ */
  function updateAtcPrice(formattedPrice) {
    var priceEl = qs('.ws-pdp-atc-price');
    if (!priceEl) return;
    /* formattedPrice comes pre-formatted from Liquid ({{ variant.price | money }})
       so it is always in the shopper's active market currency */
    if (formattedPrice) {
      priceEl.textContent = '· ' + formattedPrice;
      return;
    }
    /* span.money = actual selling price; the first .money can be the
       struck-through <s> compare-at price on sale products */
    var displayPrice = qs('.ws-pdp-price span.money');
    if (displayPrice) priceEl.textContent = '· ' + displayPrice.textContent.trim();
  }

  /* ═══════════════════════════════════════════════════════════
     ZOOM LIGHTBOX
     ═══════════════════════════════════════════════════════════ */
  function initZoom() {
    var zoomBtn = qs('.ws-pdp-zoom');
    if (!zoomBtn) return;

    zoomBtn.addEventListener('click', function () {
      /* get current image: slider or static */
      var activeSlide = qs('.ws-pdp-slide.is-active img');
      var staticImg   = qs('.ws-pdp-stage-img');
      var src = activeSlide ? activeSlide.src : (staticImg ? staticImg.src : null);
      if (!src) return;

      var overlay = document.createElement('div');
      overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,0.92);display:flex;align-items:center;justify-content:center;cursor:zoom-out;';
      var img = document.createElement('img');
      img.src = src;
      img.style.cssText = 'max-width:90vw;max-height:90vh;object-fit:contain;border-radius:12px;';
      overlay.appendChild(img);
      overlay.addEventListener('click', function () { document.body.removeChild(overlay); });
      document.body.appendChild(overlay);
    });
  }

  /* ═══════════════════════════════════════════════════════════
     SCROLL REVEAL
     ═══════════════════════════════════════════════════════════ */
  function initReveal() {
    var els = qsa('.ws-pdp-feature-card, .ws-pdp-review-card, .ws-pt-card');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity   = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el, i) {
      el.style.opacity    = '0';
      el.style.transform  = 'translateY(24px)';
      el.style.transition = 'opacity 0.5s ease ' + (i % 4 * 0.08) + 's, transform 0.5s ease ' + (i % 4 * 0.08) + 's';
      io.observe(el);
    });
  }

  /* ═══════════════════════════════════════════════════════════
     SIZE GUIDE LINK
     ═══════════════════════════════════════════════════════════ */
  function initSizeGuideLink() {
    var link = qs('a.ws-pdp-size-guide-link[href="#ws-pdp-sizing"]');
    if (!link) return;
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var section = qs('#ws-pdp-sizing');
      if (!section) return;
      var allDetails = Array.from(section.querySelectorAll('.ws-pdp-accordion-item'));
      var sizeDetails = allDetails.find(function (d) {
        return d.querySelector('summary span') &&
          d.querySelector('summary span').textContent.toLowerCase().includes('size');
      }) || allDetails[1] || allDetails[0];
      if (sizeDetails && !sizeDetails.open) sizeDetails.open = true;
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ═══════════════════════════════════════════════════════════
     DESCRIPTION LINK
     ═══════════════════════════════════════════════════════════ */
  function initDescriptionLink() {
    var link = qs('a.ws-pdp-description-link[href="#ws-pdp-description"]');
    if (!link) return;
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var details = qs('#ws-pdp-description');
      if (!details) return;
      if (!details.open) details.open = true;
      details.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ═══════════════════════════════════════════════════════════
     INIT
     ═══════════════════════════════════════════════════════════ */
  function init() {
    initSlider();
    initGallery();
    initLifestyleGallery();
    initSwatches();
    initSizes();
    initExtraOptions();
    initSoldoutStates();
    initAtcGuard();
    initServerErrorRelay();
    initQty();
    updateAtcPrice();
    initZoom();
    initReveal();
    initSizeGuideLink();
    initDescriptionLink();

    /* On variant-functionality: rebuild slider for the initially active color */
    if (isVariantTemplate) {
      var activeSwatch = qs('.ws-pdp-swatch.is-active');
      var initialColor = activeSwatch ? activeSwatch.dataset.color : null;
      if (initialColor) rebuildGalleryForColor(initialColor);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
